import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

type Params = Pick<ChallengeFormType, 'originalPrice'>;

export const validate: FormValidator<Params> = () => {
  return { isValid: true };
};
